import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'spotlight-response-header',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './response-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotlightResponseHeaderComponent {
    @Input() title: string = '';
    @Input() icon: string = '📊';
    @Input() totalRecords: number = 0;
    @Input() displayedRecords: number = 0;
    @Input() showCounter: boolean = false;
    @Input() titleSize: 'sm' | 'md' | 'lg' = 'md';

    getTitleSizeClass(): string {
        switch (this.titleSize) {
            case 'sm': return 'text-[16px]';
            case 'lg': return 'text-[24px]';
            default: return 'text-[18px]';
        }
    }
}
